module.exports = __webpack_public_path__ + "img/water01.f65187cb.png";